import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { DomSanitizer } from '@angular/platform-browser';
import { EbsWebServiceGlobals } from "../../services/ebsWebServiceGlobals";

@Component({
  selector: 'page-iframe',
  templateUrl: 'iframe.html',
  providers: [EbsWebServiceGlobals]
})
export class IFrame {

  actionURL: any;
  iframeURL: any;
  title: any;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    private sanitizer: DomSanitizer,
    private ebsWebServiceGlobals: EbsWebServiceGlobals ) {

    this.title = this.navParams.get('title');
    this.actionURL = this.navParams.get('actionURL');
    this.iframeURL = this.ebsWebServiceGlobals.getIframeURL() + this.actionURL;
  }

  getIframeURL() {
    return this.sanitizer.bypassSecurityTrustResourceUrl(this.iframeURL);
  }
}



// WEBPACK FOOTER //
// ./src/pages/iframe/iframe.ts